import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX  from 'xlsx';
import Hdr from '../shared/Hdr'

const ExcelExport = ({ data, fileName }) => {
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <button onClick={exportToExcel} 
            style={{'backgroundImage': 'linear-gradient(to right, #30AEF3, #7530F3)',
                    'marginTop':'2px',
                    'color':'white',
                    'border':'thin',
                    'height':'2rem',
                    'padding': '0.25rem',
                    'border-radius': '0.5rem'}}
            ><img src={require('../asset/icons/export_to_xl_24_24.png')} alt="" />
    </button>
  );
}

export default ExcelExport;